import type { CpHandler } from './productCard';
import { byOrderUI, toLogos } from './productCard';
import ProductItem from './ProductItem';

const defaultProductCard: CpHandler = products =>
  [...products].sort(byOrderUI).map(product => ({
    key: `${product.cps}-${product.productID}`,
    cps: product.cps,
    logos: toLogos([product]),
    primary: product,
    products: [product],
    bindingId: product.bindingId,
    Component: ProductItem
  }));

export default defaultProductCard;
